// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/profile_type_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.ProfileTypeIcon
 */
export interface ProfileTypeIcon {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIconRef profile_type_icon = 1;
     */
    profileTypeIcon?: ProfileTypeIconRef;
    /**
     * @generated from protobuf field: string src = 2;
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3;
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.ProfileTypeIconRef
 */
export interface ProfileTypeIconRef {
    /**
     * @generated from protobuf field: string profile_type_id = 1;
     */
    profileTypeId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetProfileTypeIconRequest
 */
export interface GetProfileTypeIconRequest {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIconRef profile_type_icon_ref = 1;
     */
    profileTypeIconRef?: ProfileTypeIconRef;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetProfileTypeIconResponse
 */
export interface GetProfileTypeIconResponse {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIcon profile_type_icon = 1;
     */
    profileTypeIcon?: ProfileTypeIcon;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsRequest
 */
export interface BulkGetProfileTypeIconsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.ProfileTypeIconRef profile_type_icons = 1;
     */
    profileTypeIcons: ProfileTypeIconRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsResponse
 */
export interface BulkGetProfileTypeIconsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.ProfileTypeIcon list = 1;
     */
    list: ProfileTypeIcon[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeIcon$Type extends MessageType<ProfileTypeIcon> {
    constructor() {
        super("c1.api.assets.v1.ProfileTypeIcon", [
            { no: 1, name: "profile_type_icon", kind: "message", T: () => ProfileTypeIconRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.ProfileTypeIcon
 */
export const ProfileTypeIcon = new ProfileTypeIcon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeIconRef$Type extends MessageType<ProfileTypeIconRef> {
    constructor() {
        super("c1.api.assets.v1.ProfileTypeIconRef", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.ProfileTypeIconRef
 */
export const ProfileTypeIconRef = new ProfileTypeIconRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfileTypeIconRequest$Type extends MessageType<GetProfileTypeIconRequest> {
    constructor() {
        super("c1.api.assets.v1.GetProfileTypeIconRequest", [
            { no: 1, name: "profile_type_icon_ref", kind: "message", T: () => ProfileTypeIconRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetProfileTypeIconRequest
 */
export const GetProfileTypeIconRequest = new GetProfileTypeIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfileTypeIconResponse$Type extends MessageType<GetProfileTypeIconResponse> {
    constructor() {
        super("c1.api.assets.v1.GetProfileTypeIconResponse", [
            { no: 1, name: "profile_type_icon", kind: "message", T: () => ProfileTypeIcon }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetProfileTypeIconResponse
 */
export const GetProfileTypeIconResponse = new GetProfileTypeIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetProfileTypeIconsRequest$Type extends MessageType<BulkGetProfileTypeIconsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetProfileTypeIconsRequest", [
            { no: 1, name: "profile_type_icons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeIconRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsRequest
 */
export const BulkGetProfileTypeIconsRequest = new BulkGetProfileTypeIconsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetProfileTypeIconsResponse$Type extends MessageType<BulkGetProfileTypeIconsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetProfileTypeIconsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeIcon }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsResponse
 */
export const BulkGetProfileTypeIconsResponse = new BulkGetProfileTypeIconsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.ProfileTypeIconService
 */
export const ProfileTypeIconService = new ServiceType("c1.api.assets.v1.ProfileTypeIconService", [
    { name: "GetProfileTypeIcon", options: { "authz.method": { role: "VIEWER" } }, I: GetProfileTypeIconRequest, O: GetProfileTypeIconResponse },
    { name: "BulkGetProfileTypeIcons", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetProfileTypeIconsRequest, O: BulkGetProfileTypeIconsResponse }
]);
